import logo from '@/assets/logo-klear.png'

export function Logo() {
  return (
    <div className="px-3 py-2">
      <img src={logo} alt="Logo" height={26} width={78} className="dark:invert" />
    </div>
  )
}
